export const tabSize = (size: number) => {
  if (size === 1) return "grid-cols-1";
  if (size === 2) return "grid-cols-2";
  if (size === 3) return "grid-cols-3";
  if (size === 4) return "grid-cols-4";
  if (size === 5) return "grid-cols-5";
  return "grid-cols-6";
};
